import React from "react";
import PropTypes from "prop-types";
import { Card, Col, Row } from "react-bootstrap";

import CsLineIcons from "../../cs-line-icons";

class FileItem extends React.Component {
    doOpen = () => {
        if (this.props.onOpen) {
            this.props.onOpen({ ...this.props.item });
        }
    };

    doSelect = (event) => {
        if (this.props.onSelect) {
            this.props.onSelect({
                item: { ...this.props.item },
                additive: event.ctrlKey || event.metaKey
            });
        }
    };

    doContextMenu = (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (this.props.onContextMenu) {
            this.props.onContextMenu({
                event,
                item: { ...this.props.item }
            });
        }
    };

    doKeyDown = (event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            this.doOpen();
            return;
        }

        if (event.key === " ") {
            event.preventDefault();
            this.doSelect(event);
        }
    };

    render() {
        const { item, checked } = this.props;

        const isDirectory = item.type === "directory";
        const icon = isDirectory ? "folder" : "file-empty";

        const name = item.name || "Untitled";
        const updatedAt = item.updatedAt
            ? new Date(item.updatedAt).toLocaleDateString("en-US", {
                month: "numeric",
                day: "numeric",
                year: "numeric"
            })
            : "";

        return (
            <Col xs="12" xl="6" xxl="4">
                <Card
                    className={`file-selectable mb-3 p-3 ${checked ? "border-primary shadow-sm" : ""}`}
                    data-file-uuid={item.uuid}
                    role="button"
                    tabIndex={0}
                    aria-label={`${item.type === "directory" ? "Open folder" : item.type === "agreement-draft" ? "Edit agreement" : "Open file"}: ${name}`}
                    onClick={this.doSelect}
                    onDoubleClick={this.doOpen}
                    onKeyDown={this.doKeyDown}
                    onContextMenu={this.doContextMenu}
                    style={{
                        cursor: "pointer",
                        backgroundColor: checked ? "rgba(13, 110, 253, 0.08)" : undefined
                    }}
                >
                    <Row className="align-items-center">
                        <Col xs="2">
                            <CsLineIcons
                                size="42"
                                icon={icon}
                            />
                        </Col>

                        <Col xs="10">
                            <Card.Text
                                className="text-truncate"
                                title={name}
                                style={{
                                    fontSize: "1.05rem",
                                    marginBottom: "0px",
                                    fontWeight: checked ? 600 : 400
                                }}
                            >
                                {name}
                            </Card.Text>

                            <Card.Text
                                style={{
                                    color: "gray",
                                    fontSize: ".8rem",
                                    marginBottom: "0px"
                                }}
                            >
                                {updatedAt ? `Last updated ${updatedAt}` : " "}
                            </Card.Text>
                        </Col>
                    </Row>
                </Card>
            </Col>
        );
    }
}

FileItem.propTypes = {
    item: PropTypes.object.isRequired,
    checked: PropTypes.bool,
    onOpen: PropTypes.func,
    onSelect: PropTypes.func,
    onContextMenu: PropTypes.func
};

FileItem.defaultProps = {
    checked: false
};

export default FileItem;
